import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import './calender.scss';
import Grid from './grid';
import EventForm from './eventForm';
import { DateFormat } from '../../../hooks/dateFormat'
import { Button } from 'reactstrap';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { CONSTANTS } from '../../../constants';

import { useParams } from "react-router-dom";

const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
]
const DAYS_SHORT = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
/*const pad = (input) => {
    return input < 10 ? "0" + input : input
}*/


const parseEvents = (events) => {
    return events.map(event => {
        const from = new Date(event.dateFrom)
        const to = new Date(event.dateTo)
        return {
            ...event,
            from,
            to
        }
    })
}



const Navigation = ({ date, setDate, setShowingEventForm }) => {

    
    return (
        <div className="navigation">
            <div className="back" onClick={() => {
                const newDate = new Date(date)
                newDate.setMonth(newDate.getMonth() - 1)
                setDate(newDate)
            }}>
                <MdKeyboardArrowLeft style={{fontSize:22, marginTop:'-4px'}}/> {MONTHS[date.getMonth() === 0 ? 11 : date.getMonth() - 1]}
            </div>
            <div className="monthAndYear">
                {MONTHS[date.getMonth()]} {date.getFullYear()}
                {/*<a href="javascript:;" onClick={() => setShowingEventForm({ visible: true })}>+</a>*/}
            </div>
            <div className="forward" onClick={() => {
                const newDate = new Date(date)
                newDate.setMonth(newDate.getMonth() + 1)
                setDate(newDate)
            }}>
                {MONTHS[date.getMonth() === 11 ? 0 : date.getMonth() + 1]} <MdKeyboardArrowRight style={{fontSize:22, marginTop:'-4px'}}/>
            </div>
        </div>
    )
}

const DayLabels = () => {
    return DAYS_SHORT.map((dayLabel, index) => {
        return <div className="dayLabel cell" key={index}>{dayLabel}</div>
    })
}



const Event = ({ event, setViewingEvent, setShowingEventForm, deleteEvent }) => {
    const {CURRENCY} = CONSTANTS;
    const toStartOfDay = (date) => {
        const newDate = new Date(date)
        newDate.setHours(0)
        newDate.setMinutes(0)
        newDate.setSeconds(0)
        newDate.setMilliseconds(0)
        return newDate
    }
    const currentDate = toStartOfDay(new Date())
    const { userId } = useParams();
    return (
        <Modal setViewingEvent={setViewingEvent} onClose={() => setViewingEvent(null)} title={`${event.name}`} className="eventModal">
            <p>Date <b>{DateFormat(event.dateFrom)}</b></p> 
            <p>{event.name}: <b>{(event.type === 'cost_per_click' || event.type === 'cost_per_view')?`${CURRENCY}${event.value}`:event.value}</b></p>

            {(toStartOfDay(event.dateFrom).getTime() >= currentDate.getTime()) &&
                <div>

                    {((userId && ['cost_per_click','cost_per_view'].includes(event.type)) || !userId) &&
                    <Button
                        style={{ display: 'inline-block', verticalAlign: 'baseline', width: 200, marginRight: 10 }}
                        size="sm"
                        color="primary"
                        className="border-0"
                        block
                        onClick={() => {
                            setViewingEvent(null)
                            setShowingEventForm({ visible: true, withEvent: event })
                        }}
                    >Change</Button>
}

                    
                    {/*<Button
                        style={{ display: 'inline-block', verticalAlign: 'baseline', width: 200 }}
                        size="sm"
                        color="secondary"
                        className="border-0"
                        block
                        onClick={() => deleteEvent(event)}
                    >Delete</Button>*/}
                    
                </div>
            }

        </Modal>
    )
}



// Generic component - modal to present children within
const Modal = ({ children, onClose, title, className, setViewingEvent }) => {
    return (
        <Fragment>
            <div className="overlay" onClick={onClose} />
            <div className={`modal-popup`}>
                <button style={{ marginTop: 10, marginRight: 15, fontSize: 35 }} type="button" className="close"
                    onClick={() => setViewingEvent(null)}>&times;</button>
                <h3>{title}</h3>
                <div className="inner">
                    {children}
                </div>
            </div>
        </Fragment>
    )
}

const Calendar = (props) => {

    const { month, year, preloadedEvents } = props;
    const selectedDate = new Date(year, month - 1)
    const [date, setDate] = useState(selectedDate)
    const [viewingEvent, setViewingEvent] = useState(false)
    const [showingEventForm, setShowingEventForm] = useState({ visible: false })

    const [events, setEvents] = useState([])



    useEffect(() => {
        const parsedEvents = parseEvents(preloadedEvents)
        setEvents(parsedEvents)

    }, [preloadedEvents])

    const deleteEvent = (event) => {
        props.deleteCampaignSetting({ id: event.id });
    }

    React.useEffect(() => {
        props.campaignSettingDeleted && setViewingEvent(null)
    }, [props.campaignSettingDeleted])

    return (
        <div className="calendar">
            <Navigation
                date={date}
                setDate={setDate}
                setShowingEventForm={setShowingEventForm}
            />
            <DayLabels />
            <Grid
                date={date}
                events={events}
                setShowingEventForm={setShowingEventForm}
                setViewingEvent={setViewingEvent}
                actualDate={date}
            />
            {viewingEvent &&
                <Event
                    event={viewingEvent}
                    setShowingEventForm={setShowingEventForm}
                    setViewingEvent={setViewingEvent}
                    deleteEvent={deleteEvent}
                />
            }
            {showingEventForm && showingEventForm.visible &&
                <EventForm
                    dateEvents={showingEventForm.dateEvents}
                    withEvent={showingEventForm.withEvent}
                    preselectedDate={showingEventForm.preselectedDate}
                    setShowingEventForm={setShowingEventForm}
                />
            }
        </div>
    )
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    campaignSettingDeleted: (state.campaign && state.campaign.campaignSettingDeleted) ? state.campaign.campaignSettingDeleted : null,
});
const mapDispatchToProps = (dispatch) => ({
    deleteCampaignSetting: (payload) => dispatch(CampaignAction.deleteCampaignSetting(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);

